export default {"src":"/_next/static/media/01_Telegram_EN.4580ae65.gif","height":175,"width":439};